//Components
import { Box, Typography, Fade, CircularProgress } from '@mui/material';

const SavingOverlay = ({ isVisible }) => {
  return (
    <Fade in={isVisible} timeout={300}>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(248, 250, 252, 0.4)',
          backdropFilter: 'blur(1px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10,
          borderRadius: 'inherit'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            px: 2.5,
            py: 1.5,
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
            border: '1px solid rgba(0, 0, 0, 0.03)'
          }}
        >
          <CircularProgress
            size={16}
            sx={{
              color: '#6b7280',
              '& .MuiCircularProgress-circle': {
                strokeLinecap: 'round'
              }
            }}
          />
          <Typography
            variant='body2'
            sx={{
              color: '#6b7280',
              fontWeight: 400,
              fontSize: '0.8rem'
            }}
          >
            Saving changes...
          </Typography>
        </Box>
      </Box>
    </Fade>
  );
};

export default SavingOverlay;
